import { STATUS_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { StringValue } from '../../../value/types.tsx';
import type { TransformedStatusField } from '../types.tsx';

const getStatusValue: StringValue<TransformedStatusField> = (field) => String(field.name || '');

export const statusStringValueHandler = {
	[STATUS_TYPE]: getStatusValue,
};
